var map = {
	"./a-bank-logo.png": "ed3b",
	"./apple.png": "b704",
	"./ar-nft-bg.png": "124a",
	"./ar_to_ardrive.png": "aa46",
	"./arrow-load-more.png": "c9d8",
	"./asia-logo.png": "079e",
	"./banner.png": "12ee",
	"./black-arrow.png": "970e",
	"./buy_now_arrow.png": "63b5",
	"./connectWallet/ArConnect.png": "affa",
	"./connectWallet/BitKeep.png": "edcb",
	"./connectWallet/Coinbase Wallet.png": "4d33",
	"./connectWallet/Huobi Wallet.png": "06dd",
	"./connectWallet/MathWallet.png": "ce9a",
	"./connectWallet/MetaMask.png": "cb8a",
	"./connectWallet/Safeheron.png": "233a",
	"./connectWallet/Wallet Connect.png": "4c81",
	"./connectWallet/imToken.png": "ff95",
	"./discord.png": "e74a",
	"./down.png": "7fff",
	"./down_arrow.png": "6179",
	"./email.png": "5b6b",
	"./everFinance.png": "f3b8",
	"./everPay.png": "4ab3",
	"./eye-close.png": "e479",
	"./eye-open.png": "f96a",
	"./fifa_1.png": "c351",
	"./fifa_2.png": "4449",
	"./fifa_banner.png": "bafa",
	"./fifa_win.png": "33e2",
	"./github.png": "1901",
	"./hot-nft-bg.png": "8d52",
	"./icon-down.png": "010a",
	"./icon_white_down.png": "483b",
	"./linux.png": "890e",
	"./lp_whitelist.png": "7eee",
	"./medium.png": "43f8",
	"./menu.png": "bed2",
	"./network/ar.png": "b493",
	"./network/bsc.png": "57aa",
	"./network/cfx.png": "8030",
	"./network/eth.png": "4d9b",
	"./network/moon.png": "abe1",
	"./network/platon.png": "6bec",
	"./occupancy.png": "0a88",
	"./perma_default_logo.png": "5ab9",
	"./perma_logo.png": "68e3",
	"./permaswap-logo.png": "34a8",
	"./poolBanner.png": "3883",
	"./recent_orders.png": "8cbe",
	"./red-packet-bg.png": "ca7c",
	"./red-packet-cover.png": "9ecf",
	"./rockets.png": "757a",
	"./rotation-arrow.png": "544f",
	"./search_token.png": "7b81",
	"./shutdown_banner.png": "c07b",
	"./slanted_white_arrow.png": "5831",
	"./small_banner.png": "ece0",
	"./small_default_logo.png": "8823",
	"./small_fifa_banner.png": "4e3b",
	"./swap-top-banner.png": "0f24",
	"./telegram.png": "2167",
	"./token/acnh.png": "ef50",
	"./token/ar.png": "393f",
	"./token/ardrive.png": "247f",
	"./token/arg.png": "e9b1",
	"./token/bank.png": "e5e1",
	"./token/bnb.png": "bc67",
	"./token/cfx.png": "8e50",
	"./token/dai.png": "e86a",
	"./token/dodo.png": "38c1",
	"./token/eth.png": "c67a",
	"./token/fox.png": "8664",
	"./token/fra.png": "7dd7",
	"./token/glmr.png": "b0ac",
	"./token/lat.png": "3160",
	"./token/mask.png": "e028",
	"./token/permaswap-logo.png": "cc03",
	"./token/pia.png": "2124",
	"./token/sos.png": "548c",
	"./token/t4ever.png": "a009",
	"./token/tar.png": "6388",
	"./token/tardrive.png": "9977",
	"./token/tusdc.png": "eadd",
	"./token/uni.png": "b009",
	"./token/usdc.png": "012e",
	"./token/usdt.png": "5d28",
	"./token/vrt.png": "e7e1",
	"./token/wbtc.png": "94aa",
	"./token/xsgd.png": "25f0",
	"./token/xyz.png": "ee79",
	"./token/zlk.png": "558e",
	"./top-right-green-arrow.png": "8f7a",
	"./twitter.png": "457e",
	"./user.png": "31a5",
	"./warning-icon.png": "3728",
	"./welcome_banner.png": "97dc",
	"./white-arrow.png": "4338",
	"./windows.png": "8f18",
	"./x.png": "7315",
	"./yellow_arrow.png": "2843"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d488";